import React from 'react';
import gatinho from '@/assets/images/gatinho.png';

const InicioPage = () => (
  <section className="hero">
    <div className="container">
      <div className="hero-image">
        <img src={gatinho} alt="Gatinho" className="cat-image" />
      </div>
      <div className="hero-content">
        <h2>A clínica e loja perfeita para quem ama gatos!</h2>
        <p>Cuidado especializado e produtos selecionados para o seu felino</p>
      </div>
    </div>
  </section>
);

export default InicioPage;